module.exports = __webpack_public_path__ + "static/media/formnoform.43832a33.png";